import Blockly from "blockly";
import Schema from "../schema";
import { hexToRGBA } from "./utils";

export const menu = {
  name: (<div className="text"><u>V</u>isual</div>),
  trigger: 'v',
  children: {
    'room_blood': {
      name: (<div className="text"><u>E</u>mit blood from walls</div>),
      trigger: 'e',
    },
    'room_shart': {
      name: (<div className="text">Fill room with <u>p</u>oop</div>),
      trigger: 'p',
    },
    'room_gold': {
      name: (<div className="text">Turn room <u>g</u>old</div>),
      trigger: 'g'
    },
    'room_floor_color': {
      name: (<div className="text">Set <u>f</u>loor color</div>),
      trigger: 'f'
    },
    'room_wall_color': {
      name: (<div className="text">Set <u>w</u>all color</div>),
      trigger: 'w'
    }
  }
}

/* ****************************************************************************************************************
 * Emit blood from the walls
 ******************************************************************************************************************/
Blockly.Blocks['room_blood'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Emit blood from the walls')
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Emits blood from the walls.')
  }
}

Blockly.JSON['room_blood'] = (block) => {
  return {
    action: 'room_blood',
  }
}

Schema.registerAction('room_blood', {
  "if": {
    "properties": {
      "action": {
        "const": "room_blood"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {},
        "additionalProperties": false
      }
    }
  }
});

/* ****************************************************************************************************************
 * Fill all available free tiles with poop blocks
 ******************************************************************************************************************/
Blockly.Blocks['room_shart'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Fill the room with poop')
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Fill all available free tiles with poop blocks')
  }
}

Blockly.JSON['room_shart'] = (block) => {
  return {
    action: 'room_shart',
  }
}

Schema.registerAction('room_shart', {
  "if": {
    "properties": {
      "action": {
        "const": "room_shart"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {},
        "additionalProperties": false
      }
    }
  }
});

/* ****************************************************************************************************************
 * Turn the room to gold
 ******************************************************************************************************************/
Blockly.Blocks['room_gold'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Turn the room to gold')
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Turns the current room to gold, including all item blocks (ex. poop blocks become golden poops)')
  }
}

Blockly.JSON['room_gold'] = (block) => {
  return {
    action: 'room_gold',
  }
}

Schema.registerAction('room_gold', {
  "if": {
    "properties": {
      "action": {
        "const": "room_gold"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {},
        "additionalProperties": false
      }
    }
  }
});

/* ****************************************************************************************************************
 * Set the color of the floor in the current room
 ******************************************************************************************************************/
Blockly.Blocks['room_floor_color'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Set the floor color of the current room to')
      .appendField(
        new Blockly.FieldColour(),
        'Color'
      )
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Sets the color of the floor to the specified color.')
  }
}

Blockly.JSON['room_floor_color'] = (block) => {
  const color = hexToRGBA(block.getFieldValue('Color'));

  return {
    action: 'room_floor_color',
    params: {
      ...color
    }
  }
}

Schema.registerAction('room_floor_color', {
  "if": {
    "properties": {
      "action": {
        "const": "room_floor_color"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "r": {
            "type": "number",
            "minimum": 0,
            "maximum": 255,
          },
          "g": {
            "type": "number",
            "minimum": 0,
            "maximum": 255,
          },
          "b": {
            "type": "number",
            "minimum": 0,
            "maximum": 255,
          },
          "a": {
            "type": "number",
            "minimum": 0,
            "maximum": 255,
          },
        },
        "required": [
          "r",
          "g",
          "b",
          "a",
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params",
    ]
  }
});

/* ****************************************************************************************************************
 * Set the color of the walls in the current room
 ******************************************************************************************************************/
Blockly.Blocks['room_wall_color'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Set the wall color of the current room to')
      .appendField(
        new Blockly.FieldColour(),
        'Color'
      )
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Sets the color of the walls to the specified color.')
  }
}

Blockly.JSON['room_wall_color'] = (block) => {
  const color = hexToRGBA(block.getFieldValue('Color'));

  return {
    action: 'room_wall_color',
    params: {
      ...color
    }
  }
}

Schema.registerAction('room_wall_color', {
  "if": {
    "properties": {
      "action": {
        "const": "room_wall_color"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "r": {
            "type": "number",
            "minimum": 0,
            "maximum": 255,
          },
          "g": {
            "type": "number",
            "minimum": 0,
            "maximum": 255,
          },
          "b": {
            "type": "number",
            "minimum": 0,
            "maximum": 255,
          },
          "a": {
            "type": "number",
            "minimum": 0,
            "maximum": 255,
          },
        },
        "required": [
          "r",
          "g",
          "b",
          "a",
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params",
    ]
  }
});

